import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/nico/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/nico/AssessmentPage"

const assessment = () => (
  <Layout>
    <SEO title={PAGE.title.assessment} siteTitle="nico" />
    <HeadingL title={PAGE.title.assessment} target="nico" />
    <AssessmentPage />
  </Layout>
)

export default assessment
